import {gql} from '@apollo/client';

const company = `
  name
`

export const UPDATE_COMPANY = gql`
  mutation UpdateCompany($id: ObjectId!, $record: UpdateCompanyInput!) {
    CompanyUpdateById(_id: $id, record: $record) {
      ${company}
    }
  }
`

export const GET_COMPANIES = gql`
  query CompanyMany($perPage: Int) {
    companies: CompanyMany(perPage: $perPage) {
      items {
        value: _id
        label: name
        type
      }
    }
  }
`

export const GET_COMPANY_LABEL_SCHEMA = gql`
  query GetCompanyLabelSchema($id: ObjectId!) {
    company: CompanyById(_id: $id) {
      _id
      labelSchema
    }
  }
`
